
import { ScrollView } from "@progress/kendo-react-scrollview";
// import { promises } from "dns";
import React, { Fragment, useEffect, useState } from "react";
import ErrorMessage from "../Common/Components/ErrorMessage";
import Spinner from "../Common/Components/spinner";
import { useSelector } from "react-redux";
import { updateParams, getParamsSelector } from "../Common/Slices/ParamSlice";
import { MachinePicturesApi } from "./api";
import UploadDialog from "./Upload";
import { Button } from "@progress/kendo-react-buttons";

interface MachinePicturesWidgetProps {
  id: string;
  header: string;
}

const MachinePicturesWidget = (props: MachinePicturesWidgetProps) => {
  const [machinePictures, updateMachinePictures] = useState(null);
  const [picturesLoading, updateLoadingPictures] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);
  const globalParams = useSelector(getParamsSelector);

  const [uploadVisible, updateUploadVisible] = useState(false);

  useEffect(() => {
    if (globalParams.mainMachineSerialNo != null) {
      getMachinePictures(globalParams.mainMachineSerialNo);
    }
  }, [globalParams.mainMachineSerialNo]);

    const IMAGE_BASE_URL = "https://machinefiles.blob.core.windows.net/machinefiles/";

    const isSafeImageUrl = (url?: string | null): boolean => {
        if (!url) return false;
        return url.startsWith(IMAGE_BASE_URL);
    };

  const toggleUpload = () => {
    uploadVisible ? updateUploadVisible(false) : updateUploadVisible(true);
  };
  const getMachinePictures = (m) => {
    let params: any = { machineSerial: m };
    MachinePicturesApi.getMachinePictures(params)
      .then((url: any) => {
        const picObjects: any = [];
        for (var i = 0; i < url.length; i++) {
          if (!url[i].includes("thumbnail")) {
            var obj: any = {};
            obj.url = url[i];
            obj.position = i + 1;
            var fileName = url[i].split("?")[0];
            obj.fileName = fileName.split("Images/")[1];
            picObjects.push(obj);
          }
        }
        updateMachinePictures(picObjects);
        updateLoadingPictures(false);

        setErrorMessage(null);
      })
      .catch((error) => {
        updateLoadingPictures(false);
        setErrorMessage("Oops something went wrong, unable to get data.");

        console.log(error);
      });
  };

  if (picturesLoading) {
    return <Spinner text="machine pictures" />;
  }
  if (errorMessage != null) {
    return (
      <>
        <br />
        <ErrorMessage
          text={"No data found"}
          id={props.id}
          header={props.header}
        />
      </>
    );
  }
  return (
    <>
      <ScrollView
        style={{ width: "700px", height: "calc(100% - 40px)" }}
        activeView={1}
        automaticViewChange={false}
        pagerOverlay={"dark"}
      >
              {machinePictures.filter(item => isSafeImageUrl(item.url)).map((item, index) => {
          return (
            <div className="image-with-text" key={index}>
              <p>
                Showing image {item.position} of {machinePictures.length}.
              </p>
              <img
                src={item.url}
                alt={`KendoReact ScrollView Photo ${item.position}`}
                style={{ width: "100%" }}
                draggable={false}
              />
            </div>
          );
        })}
      </ScrollView>
      <div style={{ margin: "10px" }}>
        <Button onClick={() => toggleUpload()}>Upload</Button>
      </div>
      <UploadDialog
        visible={uploadVisible}
        toggleVisible={toggleUpload}
        machineSerial={globalParams.mainMachineSerialNo}
      />
    </>
  );
};

export default MachinePicturesWidget;
